import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchUsersList = (params) =>
  apiActionCreator({
    'endpoint': `/users${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USERS_LIST,
      ActionTypes.FETCHED_USERS_LIST,
      [
        ActionTypes.FETCHED_USERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUsersRequests = (params) =>
  apiActionCreator({
    'endpoint': `/users/request${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USERS_REQUESTS_LIST,
      ActionTypes.FETCHED_USERS_REQUESTS_LIST,
      [
        ActionTypes.FETCHED_USERS_REQUESTS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUserRequestInfo = (id) =>
  apiActionCreator({
    'endpoint': `/users/request/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USER_REQUEST_INFO,
      ActionTypes.FETCHED_USER_REQUEST_INFO,
      [
        ActionTypes.FETCHED_USER_REQUEST_INFO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUsersPolicies = () =>
  apiActionCreator({
    'endpoint': '/users/policies',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USERS_POLICIES_LIST,
      ActionTypes.FETCHED_USERS_POLICIES_LIST,
      [
        ActionTypes.FETCHED_USERS_POLICIES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUsersfromDirectory = () =>
  apiActionCreator({
    'endpoint': '/users/directory',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USERS_FROM_DIRECTORY,
      ActionTypes.FETCHED_USERS_FROM_DIRECTORY,
      [
        ActionTypes.FETCHED_USERS_FROM_DIRECTORY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchPermissionFromPolicy = (id) =>
  apiActionCreator({
    'endpoint': `/users/policies/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USERS_PERMISSIONS_LIST,
      ActionTypes.FETCHED_USERS_PERMISSIONS_LIST,
      [
        ActionTypes.FETCHED_USERS_PERMISSIONS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const checkUserInfo = (params) => apiActionCreator({
  'endpoint': `/users/validation${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.CHECKING_USER_INFO,
    ActionTypes.CHECKED_USER_INFO,
    [
      ActionTypes.CHECKED_USER_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addNewUserRequest = (data = {}) =>
  apiActionCreator({
    'endpoint': '/users/request',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_USER_REQUEST,
      [
        ActionTypes.ADDED_USER_REQUEST,
        MessageActions.addMessageBoxInfo('Solicitud de usuario creada satisfactoriamente'),
      ],
      [
        ActionTypes.ADDED_USER_REQUEST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const updateUserRequest = (id, data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/users/request/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_USER_REQUEST,
        [
          () => {
            return {
              'type': ActionTypes.UPDATED_USER_REQUEST,
            };
          },
          (response) => {
            const {status} = response.data.userInfo;
            const {isUserFromTDE, dealerId} = data;
            if (status === 'R') {
              return MessageActions.addMessageBoxInfo(
                'La solicitud ha sido rechazada'
              );
            }
            if (status === 'D') {
              if (!isUserFromTDE) {
                dispatch(fetchUsersRequests({'status': 'I', dealerId}));
              } else {
                dispatch(fetchUsersRequests({'status': 'E'}));
              }

              return MessageActions.addMessageBoxInfo(
                'Solicitud eliminada'
              );
            }
            if (status !== 'E') {
              return MessageActions.addMessageBoxInfo(
                'Usuario actualizado satisfactoriamente'
              );
            }
            return MessageActions.addMessageBoxInfo(
              'Usuario actualizado satisfactoriamente y notificacion enviada'
            );
          },
        ],
        [
          ActionTypes.UPDATED_USER_REQUEST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const addNewUser =
  (code, isTdeUserNew, params, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/users/create${getUrlParameters(params)}`,
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_NEW_USER,
            [
              () => {
                return {
                  'type': ActionTypes.ADDED_NEW_USER,
                };
              },
              (response) => {
                if (!isTdeUserNew) {
                  dispatch(updateUserRequest(code, data));
                }
                return MessageActions.addMessageBoxInfo(
                  'Usuario creado satisfactoriamente'
                );
              },
            ],
            [
              ActionTypes.ADDED_NEW_USER_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const updateUser = (userId, params, data = {}) =>
  apiActionCreator({
    'endpoint': `/users/${userId}${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_USER,
      [
        ActionTypes.UPDATED_USER,
        MessageActions.addMessageBoxInfo(
          'Usuario actualizado satisfactoriamente'
        ),
      ],
      [ActionTypes.UPDATED_USER_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });


export const fetchUserByParams = (userId, params) =>
  apiActionCreator({
    'endpoint': `/users/${userId}${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_USER,
      ActionTypes.FETCHED_USER,
      [ActionTypes.FETCHED_USER_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const setUserFromDirectory = (username, directory) => ({
  'type': ActionTypes.SET_USER_FROM_DIRECTORY,
  'payload': {username, directory},
});

export const clearUserForm = () => ({
  'type': ActionTypes.CLEAR_USER_FORM,
});

export const clearUserList = () => ({
  'type': ActionTypes.CLEAR_USER_LIST,
});

export const setUserField = (field, value) => ({
  'type': ActionTypes.SET_USER_FIELD_VALUE,
  'payload': {field, value},
});

export const setUserTdeNew = () => ({
  'type': ActionTypes.SET_USER_TDE_NEW,
});

export const clearUserRequests = () => ({
  'type': ActionTypes.CLEAR_USER_REQUESTS_LIST,
});
